// This file was generated by a custom prisma generator, do not edit manually.
export const ReferralRewardStatus = {
  Pending: 'Pending',
  Settled: 'Settled',
  Redeemed: 'Redeemed',
  Expired: 'Expired',
  Revoked: 'Revoked',
} as const;

export type ReferralRewardStatus = (typeof ReferralRewardStatus)[keyof typeof ReferralRewardStatus];

export const ReferralRewardKind = {
  MembershipToken: 'MembershipToken',
  BuzzKickback: 'BuzzKickback',
  MilestoneBonus: 'MilestoneBonus',
  RefereeBonus: 'RefereeBonus',
} as const;

export type ReferralRewardKind = (typeof ReferralRewardKind)[keyof typeof ReferralRewardKind];

export const ReferralRedemptionType = {
  MembershipPerks: 'MembershipPerks',
} as const;

export type ReferralRedemptionType =
  (typeof ReferralRedemptionType)[keyof typeof ReferralRedemptionType];

export const BuzzWithdrawalRequestStatus = {
  Requested: 'Requested',
  Canceled: 'Canceled',
  Rejected: 'Rejected',
  Approved: 'Approved',
  Reverted: 'Reverted',
  Transferred: 'Transferred',
  ExternallyResolved: 'ExternallyResolved',
} as const;

export type BuzzWithdrawalRequestStatus =
  (typeof BuzzWithdrawalRequestStatus)[keyof typeof BuzzWithdrawalRequestStatus];

export const UserPaymentConfigurationProvider = {
  Stripe: 'Stripe',
  Tipalti: 'Tipalti',
} as const;

export type UserPaymentConfigurationProvider =
  (typeof UserPaymentConfigurationProvider)[keyof typeof UserPaymentConfigurationProvider];

export const CashWithdrawalStatus = {
  Paid: 'Paid',
  Rejected: 'Rejected',
  Scheduled: 'Scheduled',
  Submitted: 'Submitted',
  Deferred: 'Deferred',
  DeferredInternal: 'DeferredInternal',
  Canceled: 'Canceled',
  Cleared: 'Cleared',
  FraudReview: 'FraudReview',
  PendingPayerFunds: 'PendingPayerFunds',
  InternalValue: 'InternalValue',
  FailedFee: 'FailedFee',
  Reclaimed: 'Reclaimed',
} as const;

export type CashWithdrawalStatus = (typeof CashWithdrawalStatus)[keyof typeof CashWithdrawalStatus];

export const CashWithdrawalMethod = {
  NoPM: 'NoPM',
  WireTransfer: 'WireTransfer',
  Payoneer: 'Payoneer',
  PayPal: 'PayPal',
  ACH: 'ACH',
  Check: 'Check',
  eCheck: 'eCheck',
  HoldMyPayments: 'HoldMyPayments',
  Custom: 'Custom',
  Intercash: 'Intercash',
  Card: 'Card',
  TipaltiInternalValue: 'TipaltiInternalValue',
} as const;

export type CashWithdrawalMethod = (typeof CashWithdrawalMethod)[keyof typeof CashWithdrawalMethod];

export const CryptoTransactionStatus = {
  WaitingForRamp: 'WaitingForRamp',
  RampTimedOut: 'RampTimedOut',
  RampFailed: 'RampFailed',
  RampInProgress: 'RampInProgress',
  RampSuccess: 'RampSuccess',
  WaitingForSweep: 'WaitingForSweep',
  SweepFailed: 'SweepFailed',
  Complete: 'Complete',
} as const;

export type CryptoTransactionStatus =
  (typeof CryptoTransactionStatus)[keyof typeof CryptoTransactionStatus];

export const RewardsEligibility = {
  Eligible: 'Eligible',
  Ineligible: 'Ineligible',
  Protected: 'Protected',
} as const;

export type RewardsEligibility = (typeof RewardsEligibility)[keyof typeof RewardsEligibility];

export const PaymentProvider = {
  Stripe: 'Stripe',
  Paddle: 'Paddle',
  Civitai: 'Civitai',
} as const;

export type PaymentProvider = (typeof PaymentProvider)[keyof typeof PaymentProvider];

export const MembershipGiftStatus = {
  Pending: 'Pending',
  Fulfilled: 'Fulfilled',
  Failed: 'Failed',
  Refunded: 'Refunded',
  Revoked: 'Revoked',
} as const;

export type MembershipGiftStatus = (typeof MembershipGiftStatus)[keyof typeof MembershipGiftStatus];

export const UserEngagementType = {
  Follow: 'Follow',
  Hide: 'Hide',
  Block: 'Block',
} as const;

export type UserEngagementType = (typeof UserEngagementType)[keyof typeof UserEngagementType];

export const LinkType = {
  Sponsorship: 'Sponsorship',
  Social: 'Social',
  Other: 'Other',
} as const;

export type LinkType = (typeof LinkType)[keyof typeof LinkType];

export const ModelType = {
  Checkpoint: 'Checkpoint',
  TextualInversion: 'TextualInversion',
  Hypernetwork: 'Hypernetwork',
  AestheticGradient: 'AestheticGradient',
  LORA: 'LORA',
  LoCon: 'LoCon',
  DoRA: 'DoRA',
  Controlnet: 'Controlnet',
  Upscaler: 'Upscaler',
  MotionModule: 'MotionModule',
  VAE: 'VAE',
  TextEncoder: 'TextEncoder',
  UNet: 'UNet',
  CLIPVision: 'CLIPVision',
  Poses: 'Poses',
  Wildcards: 'Wildcards',
  Workflows: 'Workflows',
  ComfyWorkflows: 'ComfyWorkflows',
  Detection: 'Detection',
  VisionLanguage: 'VisionLanguage',
  CLIP: 'CLIP',
  LLM: 'LLM',
  Other: 'Other',
} as const;

export type ModelType = (typeof ModelType)[keyof typeof ModelType];

export const ImportStatus = {
  Pending: 'Pending',
  Processing: 'Processing',
  Failed: 'Failed',
  Completed: 'Completed',
} as const;

export type ImportStatus = (typeof ImportStatus)[keyof typeof ImportStatus];

export const ModelStatus = {
  Draft: 'Draft',
  Training: 'Training',
  Published: 'Published',
  Scheduled: 'Scheduled',
  Unpublished: 'Unpublished',
  UnpublishedViolation: 'UnpublishedViolation',
  GatherInterest: 'GatherInterest',
  Deleted: 'Deleted',
} as const;

export type ModelStatus = (typeof ModelStatus)[keyof typeof ModelStatus];

export const TrainingStatus = {
  Pending: 'Pending',
  Submitted: 'Submitted',
  Paused: 'Paused',
  Denied: 'Denied',
  Processing: 'Processing',
  InReview: 'InReview',
  Failed: 'Failed',
  Approved: 'Approved',
  Expired: 'Expired',
} as const;

export type TrainingStatus = (typeof TrainingStatus)[keyof typeof TrainingStatus];

export const CommercialUse = {
  None: 'None',
  Image: 'Image',
  RentCivit: 'RentCivit',
  Rent: 'Rent',
  Sell: 'Sell',
} as const;

export type CommercialUse = (typeof CommercialUse)[keyof typeof CommercialUse];

export const CheckpointType = {
  Trained: 'Trained',
  Merge: 'Merge',
} as const;

export type CheckpointType = (typeof CheckpointType)[keyof typeof CheckpointType];

export const ModelUploadType = {
  Created: 'Created',
  Trained: 'Trained',
} as const;

export type ModelUploadType = (typeof ModelUploadType)[keyof typeof ModelUploadType];

export const ModelUsageControl = {
  Download: 'Download',
  Generation: 'Generation',
  InternalGeneration: 'InternalGeneration',
  ExternalGeneration: 'ExternalGeneration',
} as const;

export type ModelUsageControl = (typeof ModelUsageControl)[keyof typeof ModelUsageControl];

export const ModelModifier = {
  Archived: 'Archived',
  TakenDown: 'TakenDown',
} as const;

export type ModelModifier = (typeof ModelModifier)[keyof typeof ModelModifier];

export const ContentType = {
  Image: 'Image',
  Character: 'Character',
  Text: 'Text',
  Audio: 'Audio',
} as const;

export type ContentType = (typeof ContentType)[keyof typeof ContentType];

export const ModelFlagStatus = {
  Pending: 'Pending',
  Resolved: 'Resolved',
} as const;

export type ModelFlagStatus = (typeof ModelFlagStatus)[keyof typeof ModelFlagStatus];

export const ModelEngagementType = {
  Favorite: 'Favorite',
  Hide: 'Hide',
  Mute: 'Mute',
  Notify: 'Notify',
} as const;

export type ModelEngagementType = (typeof ModelEngagementType)[keyof typeof ModelEngagementType];

export const ModelVersionSponsorshipSettingsType = {
  FixedPrice: 'FixedPrice',
  Bidding: 'Bidding',
} as const;

export type ModelVersionSponsorshipSettingsType =
  (typeof ModelVersionSponsorshipSettingsType)[keyof typeof ModelVersionSponsorshipSettingsType];

export const ModelVersionMonetizationType = {
  PaidAccess: 'PaidAccess',
  PaidEarlyAccess: 'PaidEarlyAccess',
  PaidGeneration: 'PaidGeneration',
  CivitaiClubOnly: 'CivitaiClubOnly',
  MySubscribersOnly: 'MySubscribersOnly',
  Sponsored: 'Sponsored',
} as const;

export type ModelVersionMonetizationType =
  (typeof ModelVersionMonetizationType)[keyof typeof ModelVersionMonetizationType];

export const LicensingFeeType = {
  PerImageBuzz: 'PerImageBuzz',
} as const;

export type LicensingFeeType = (typeof LicensingFeeType)[keyof typeof LicensingFeeType];

export const LicensingFeeSettlementCurrency = {
  Buzz: 'Buzz',
  Cash: 'Cash',
} as const;

export type LicensingFeeSettlementCurrency =
  (typeof LicensingFeeSettlementCurrency)[keyof typeof LicensingFeeSettlementCurrency];

export const ModelVersionEngagementType = {
  Notify: 'Notify',
} as const;

export type ModelVersionEngagementType =
  (typeof ModelVersionEngagementType)[keyof typeof ModelVersionEngagementType];

export const ModelHashType = {
  AutoV1: 'AutoV1',
  AutoV2: 'AutoV2',
  AutoV3: 'AutoV3',
  SHA256: 'SHA256',
  CRC32: 'CRC32',
  BLAKE3: 'BLAKE3',
  SHA256_12: 'SHA256_12',
} as const;

export type ModelHashType = (typeof ModelHashType)[keyof typeof ModelHashType];

export const ScanResultCode = {
  Pending: 'Pending',
  Success: 'Success',
  Danger: 'Danger',
  Error: 'Error',
} as const;

export type ScanResultCode = (typeof ScanResultCode)[keyof typeof ScanResultCode];

export const ModelFileVisibility = {
  Sensitive: 'Sensitive',
  Private: 'Private',
  Public: 'Public',
} as const;

export type ModelFileVisibility = (typeof ModelFileVisibility)[keyof typeof ModelFileVisibility];

export const MetricTimeframe = {
  Day: 'Day',
  Week: 'Week',
  Month: 'Month',
  Year: 'Year',
  AllTime: 'AllTime',
} as const;

export type MetricTimeframe = (typeof MetricTimeframe)[keyof typeof MetricTimeframe];

export const AssociationType = {
  Suggested: 'Suggested',
} as const;

export type AssociationType = (typeof AssociationType)[keyof typeof AssociationType];

export const ReportReason = {
  TOSViolation: 'TOSViolation',
  NSFW: 'NSFW',
  Ownership: 'Ownership',
  AdminAttention: 'AdminAttention',
  Claim: 'Claim',
  CSAM: 'CSAM',
  Automated: 'Automated',
  Spam: 'Spam',
  StickerPlacement: 'StickerPlacement',
} as const;

export type ReportReason = (typeof ReportReason)[keyof typeof ReportReason];

export const ReportStatus = {
  Pending: 'Pending',
  Processing: 'Processing',
  Actioned: 'Actioned',
  Unactioned: 'Unactioned',
} as const;

export type ReportStatus = (typeof ReportStatus)[keyof typeof ReportStatus];

export const ReviewReactions = {
  Like: 'Like',
  Dislike: 'Dislike',
  Laugh: 'Laugh',
  Cry: 'Cry',
  Heart: 'Heart',
} as const;

export type ReviewReactions = (typeof ReviewReactions)[keyof typeof ReviewReactions];

export const ImageGenerationProcess = {
  txt2img: 'txt2img',
  txt2imgHiRes: 'txt2imgHiRes',
  img2img: 'img2img',
  inpainting: 'inpainting',
} as const;

export type ImageGenerationProcess =
  (typeof ImageGenerationProcess)[keyof typeof ImageGenerationProcess];

export const NsfwLevel = {
  None: 'None',
  Soft: 'Soft',
  Mature: 'Mature',
  X: 'X',
  Blocked: 'Blocked',
} as const;

export type NsfwLevel = (typeof NsfwLevel)[keyof typeof NsfwLevel];

export const ImageIngestionStatus = {
  Pending: 'Pending',
  Scanned: 'Scanned',
  Error: 'Error',
  Blocked: 'Blocked',
  NotFound: 'NotFound',
  PendingManualAssignment: 'PendingManualAssignment',
  Rescan: 'Rescan',
} as const;

export type ImageIngestionStatus = (typeof ImageIngestionStatus)[keyof typeof ImageIngestionStatus];

export const MediaType = {
  image: 'image',
  video: 'video',
  audio: 'audio',
} as const;

export type MediaType = (typeof MediaType)[keyof typeof MediaType];

export const BlockImageReason = {
  Ownership: 'Ownership',
  CSAM: 'CSAM',
  TOS: 'TOS',
} as const;

export type BlockImageReason = (typeof BlockImageReason)[keyof typeof BlockImageReason];

export const EntityModerationStatus = {
  Pending: 'Pending',
  Succeeded: 'Succeeded',
  Failed: 'Failed',
  Expired: 'Expired',
  Canceled: 'Canceled',
} as const;

export type EntityModerationStatus =
  (typeof EntityModerationStatus)[keyof typeof EntityModerationStatus];

export const ImageEngagementType = {
  Favorite: 'Favorite',
  Hide: 'Hide',
} as const;

export type ImageEngagementType = (typeof ImageEngagementType)[keyof typeof ImageEngagementType];

export const ImageOnModelType = {
  Example: 'Example',
  Training: 'Training',
} as const;

export type ImageOnModelType = (typeof ImageOnModelType)[keyof typeof ImageOnModelType];

export const TagTarget = {
  Model: 'Model',
  Question: 'Question',
  Image: 'Image',
  Post: 'Post',
  Tag: 'Tag',
  Article: 'Article',
  Bounty: 'Bounty',
  Collection: 'Collection',
  Model3D: 'Model3D',
} as const;

export type TagTarget = (typeof TagTarget)[keyof typeof TagTarget];

export const TagType = {
  UserGenerated: 'UserGenerated',
  Label: 'Label',
  Moderation: 'Moderation',
  System: 'System',
} as const;

export type TagType = (typeof TagType)[keyof typeof TagType];

export const TagsOnTagsType = {
  Parent: 'Parent',
  Replace: 'Replace',
  Append: 'Append',
} as const;

export type TagsOnTagsType = (typeof TagsOnTagsType)[keyof typeof TagsOnTagsType];

export const TagSource = {
  User: 'User',
  Rekognition: 'Rekognition',
  WD14: 'WD14',
  Computed: 'Computed',
  ImageHash: 'ImageHash',
  Hive: 'Hive',
  MinorDetection: 'MinorDetection',
  HiveDemographics: 'HiveDemographics',
  Clavata: 'Clavata',
  SpineRating: 'SpineRating',
  AiRecognition: 'AiRecognition',
  AnimeRecognition: 'AnimeRecognition',
} as const;

export type TagSource = (typeof TagSource)[keyof typeof TagSource];

export const PartnerPricingModel = {
  Duration: 'Duration',
  PerImage: 'PerImage',
} as const;

export type PartnerPricingModel = (typeof PartnerPricingModel)[keyof typeof PartnerPricingModel];

export const ApiKeyType = {
  System: 'System',
  User: 'User',
  Access: 'Access',
  Refresh: 'Refresh',
} as const;

export type ApiKeyType = (typeof ApiKeyType)[keyof typeof ApiKeyType];

export const TagEngagementType = {
  Hide: 'Hide',
  Follow: 'Follow',
  Allow: 'Allow',
} as const;

export type TagEngagementType = (typeof TagEngagementType)[keyof typeof TagEngagementType];

export const DomainColor = {
  red: 'red',
  green: 'green',
  blue: 'blue',
  all: 'all',
} as const;

export type DomainColor = (typeof DomainColor)[keyof typeof DomainColor];

export const CosmeticType = {
  Badge: 'Badge',
  NamePlate: 'NamePlate',
  ContentDecoration: 'ContentDecoration',
  ProfileDecoration: 'ProfileDecoration',
  ProfileBackground: 'ProfileBackground',
  Sticker: 'Sticker',
  ChatTheme: 'ChatTheme',
} as const;

export type CosmeticType = (typeof CosmeticType)[keyof typeof CosmeticType];

export const CosmeticSource = {
  Trophy: 'Trophy',
  Purchase: 'Purchase',
  Event: 'Event',
  Membership: 'Membership',
  Claim: 'Claim',
} as const;

export type CosmeticSource = (typeof CosmeticSource)[keyof typeof CosmeticSource];

export const CosmeticShopItemStatus = {
  Draft: 'Draft',
  PendingReview: 'PendingReview',
  Published: 'Published',
  Rejected: 'Rejected',
  RequestedChanges: 'RequestedChanges',
  Archived: 'Archived',
} as const;

export type CosmeticShopItemStatus =
  (typeof CosmeticShopItemStatus)[keyof typeof CosmeticShopItemStatus];

export const CosmeticEntity = {
  Model: 'Model',
  Image: 'Image',
  Article: 'Article',
  Post: 'Post',
  Model3D: 'Model3D',
} as const;

export type CosmeticEntity = (typeof CosmeticEntity)[keyof typeof CosmeticEntity];

export const BuzzAccountType = {
  user: 'user',
  generation: 'generation',
  club: 'club',
  green: 'green',
  fakered: 'fakered',
} as const;

export type BuzzAccountType = (typeof BuzzAccountType)[keyof typeof BuzzAccountType];

export const ArticleStatus = {
  Draft: 'Draft',
  Published: 'Published',
  Unpublished: 'Unpublished',
  UnpublishedViolation: 'UnpublishedViolation',
  Processing: 'Processing',
} as const;

export type ArticleStatus = (typeof ArticleStatus)[keyof typeof ArticleStatus];

export const ArticleIngestionStatus = {
  Pending: 'Pending',
  Scanned: 'Scanned',
  Blocked: 'Blocked',
  Error: 'Error',
  Rescan: 'Rescan',
} as const;

export type ArticleIngestionStatus =
  (typeof ArticleIngestionStatus)[keyof typeof ArticleIngestionStatus];

export const ArticleEngagementType = {
  Favorite: 'Favorite',
  Hide: 'Hide',
} as const;

export type ArticleEngagementType =
  (typeof ArticleEngagementType)[keyof typeof ArticleEngagementType];

export const GenerationSchedulers = {
  EulerA: 'EulerA',
  Euler: 'Euler',
  LMS: 'LMS',
  Heun: 'Heun',
  DPM2: 'DPM2',
  DPM2A: 'DPM2A',
  DPM2SA: 'DPM2SA',
  DPM2M: 'DPM2M',
  DPMSDE: 'DPMSDE',
  DPMFast: 'DPMFast',
  DPMAdaptive: 'DPMAdaptive',
  LMSKarras: 'LMSKarras',
  DPM2Karras: 'DPM2Karras',
  DPM2AKarras: 'DPM2AKarras',
  DPM2SAKarras: 'DPM2SAKarras',
  DPM2MKarras: 'DPM2MKarras',
  DPMSDEKarras: 'DPMSDEKarras',
  DDIM: 'DDIM',
} as const;

export type GenerationSchedulers = (typeof GenerationSchedulers)[keyof typeof GenerationSchedulers];

export const CollectionWriteConfiguration = {
  Private: 'Private',
  Public: 'Public',
  Review: 'Review',
} as const;

export type CollectionWriteConfiguration =
  (typeof CollectionWriteConfiguration)[keyof typeof CollectionWriteConfiguration];

export const CollectionReadConfiguration = {
  Private: 'Private',
  Public: 'Public',
  Unlisted: 'Unlisted',
} as const;

export type CollectionReadConfiguration =
  (typeof CollectionReadConfiguration)[keyof typeof CollectionReadConfiguration];

export const CollectionType = {
  Model: 'Model',
  Article: 'Article',
  Post: 'Post',
  Image: 'Image',
  Model3D: 'Model3D',
} as const;

export type CollectionType = (typeof CollectionType)[keyof typeof CollectionType];

export const CollectionMode = {
  Contest: 'Contest',
  Bookmark: 'Bookmark',
} as const;

export type CollectionMode = (typeof CollectionMode)[keyof typeof CollectionMode];

export const CollectionItemStatus = {
  ACCEPTED: 'ACCEPTED',
  REVIEW: 'REVIEW',
  REJECTED: 'REJECTED',
} as const;

export type CollectionItemStatus = (typeof CollectionItemStatus)[keyof typeof CollectionItemStatus];

export const CollectionItemRejectionReason = {
  OffTopic: 'OffTopic',
  WrongFormat: 'WrongFormat',
  Duplicate: 'Duplicate',
  Quality: 'Quality',
  RulesViolation: 'RulesViolation',
  Other: 'Other',
  Automated: 'Automated',
} as const;

export type CollectionItemRejectionReason =
  (typeof CollectionItemRejectionReason)[keyof typeof CollectionItemRejectionReason];

export const CollectionContributorPermission = {
  VIEW: 'VIEW',
  ADD: 'ADD',
  ADD_REVIEW: 'ADD_REVIEW',
  MANAGE: 'MANAGE',
} as const;

export type CollectionContributorPermission =
  (typeof CollectionContributorPermission)[keyof typeof CollectionContributorPermission];

export const CollectionCollaboratorRole = {
  Contributor: 'Contributor',
  Manager: 'Manager',
} as const;

export type CollectionCollaboratorRole =
  (typeof CollectionCollaboratorRole)[keyof typeof CollectionCollaboratorRole];

export const CollectionInviteStatus = {
  Pending: 'Pending',
  Accepted: 'Accepted',
  Declined: 'Declined',
} as const;

export type CollectionInviteStatus =
  (typeof CollectionInviteStatus)[keyof typeof CollectionInviteStatus];

export const HomeBlockType = {
  Collection: 'Collection',
  Announcement: 'Announcement',
  Leaderboard: 'Leaderboard',
  Social: 'Social',
  Event: 'Event',
  CosmeticShop: 'CosmeticShop',
  FeaturedModelVersion: 'FeaturedModelVersion',
  FeaturedCollections: 'FeaturedCollections',
  Feed: 'Feed',
} as const;

export type HomeBlockType = (typeof HomeBlockType)[keyof typeof HomeBlockType];

export const Currency = {
  USD: 'USD',
  BUZZ: 'BUZZ',
  USDC: 'USDC',
} as const;

export type Currency = (typeof Currency)[keyof typeof Currency];

export const BountyType = {
  ModelCreation: 'ModelCreation',
  LoraCreation: 'LoraCreation',
  EmbedCreation: 'EmbedCreation',
  DataSetCreation: 'DataSetCreation',
  DataSetCaption: 'DataSetCaption',
  ImageCreation: 'ImageCreation',
  VideoCreation: 'VideoCreation',
  Other: 'Other',
} as const;

export type BountyType = (typeof BountyType)[keyof typeof BountyType];

export const BountyMode = {
  Individual: 'Individual',
  Split: 'Split',
} as const;

export type BountyMode = (typeof BountyMode)[keyof typeof BountyMode];

export const BountyEntryMode = {
  Open: 'Open',
  BenefactorsOnly: 'BenefactorsOnly',
} as const;

export type BountyEntryMode = (typeof BountyEntryMode)[keyof typeof BountyEntryMode];

export const BountyEngagementType = {
  Favorite: 'Favorite',
  Track: 'Track',
} as const;

export type BountyEngagementType = (typeof BountyEngagementType)[keyof typeof BountyEngagementType];

export const CsamReportType = {
  Image: 'Image',
  TrainingData: 'TrainingData',
  GeneratedImage: 'GeneratedImage',
  ExternalLink: 'ExternalLink',
} as const;

export type CsamReportType = (typeof CsamReportType)[keyof typeof CsamReportType];

export const Availability = {
  Public: 'Public',
  Unsearchable: 'Unsearchable',
  Private: 'Private',
  EarlyAccess: 'EarlyAccess',
} as const;

export type Availability = (typeof Availability)[keyof typeof Availability];

export const PaidAccessEntityType = {
  ModelVersion: 'ModelVersion',
  ComicChapter: 'ComicChapter',
} as const;

export type PaidAccessEntityType = (typeof PaidAccessEntityType)[keyof typeof PaidAccessEntityType];

export const SaleDiscountType = {
  Fixed: 'Fixed',
  Percent: 'Percent',
} as const;

export type SaleDiscountType = (typeof SaleDiscountType)[keyof typeof SaleDiscountType];

export const EntityCollaboratorStatus = {
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected',
} as const;

export type EntityCollaboratorStatus =
  (typeof EntityCollaboratorStatus)[keyof typeof EntityCollaboratorStatus];

export const ClubAdminPermission = {
  ManageMemberships: 'ManageMemberships',
  ManageTiers: 'ManageTiers',
  ManagePosts: 'ManagePosts',
  ManageClub: 'ManageClub',
  ManageResources: 'ManageResources',
  ViewRevenue: 'ViewRevenue',
  WithdrawRevenue: 'WithdrawRevenue',
} as const;

export type ClubAdminPermission = (typeof ClubAdminPermission)[keyof typeof ClubAdminPermission];

export const ChatMemberStatus = {
  Invited: 'Invited',
  Joined: 'Joined',
  Ignored: 'Ignored',
  Left: 'Left',
  Kicked: 'Kicked',
} as const;

export type ChatMemberStatus = (typeof ChatMemberStatus)[keyof typeof ChatMemberStatus];

export const ChatNotifyLevel = {
  All: 'All',
  Mentions: 'Mentions',
  None: 'None',
} as const;

export type ChatNotifyLevel = (typeof ChatNotifyLevel)[keyof typeof ChatNotifyLevel];

export const ChatMessageType = {
  Markdown: 'Markdown',
  Image: 'Image',
  Video: 'Video',
  Audio: 'Audio',
  Embed: 'Embed',
} as const;

export type ChatMessageType = (typeof ChatMessageType)[keyof typeof ChatMessageType];

export const PurchasableRewardUsage = {
  SingleUse: 'SingleUse',
  MultiUse: 'MultiUse',
} as const;

export type PurchasableRewardUsage =
  (typeof PurchasableRewardUsage)[keyof typeof PurchasableRewardUsage];

export const EntityType = {
  Image: 'Image',
  Post: 'Post',
  Article: 'Article',
  Bounty: 'Bounty',
  BountyEntry: 'BountyEntry',
  ModelVersion: 'ModelVersion',
  Model: 'Model',
  Collection: 'Collection',
  Comment: 'Comment',
  CommentV2: 'CommentV2',
  User: 'User',
  UserProfile: 'UserProfile',
  ResourceReview: 'ResourceReview',
  ChatMessage: 'ChatMessage',
  Model3D: 'Model3D',
} as const;

export type EntityType = (typeof EntityType)[keyof typeof EntityType];

export const JobQueueType = {
  CleanUp: 'CleanUp',
  UpdateMetrics: 'UpdateMetrics',
  UpdateNsfwLevel: 'UpdateNsfwLevel',
  UpdateSearchIndex: 'UpdateSearchIndex',
  CleanIfEmpty: 'CleanIfEmpty',
  ModerationRequest: 'ModerationRequest',
  BlockedImageDelete: 'BlockedImageDelete',
  ImageScan: 'ImageScan',
  ReplacedImageDelete: 'ReplacedImageDelete',
} as const;

export type JobQueueType = (typeof JobQueueType)[keyof typeof JobQueueType];

export const VaultItemStatus = {
  Pending: 'Pending',
  Stored: 'Stored',
  Failed: 'Failed',
} as const;

export type VaultItemStatus = (typeof VaultItemStatus)[keyof typeof VaultItemStatus];

export const RedeemableCodeType = {
  Buzz: 'Buzz',
  Membership: 'Membership',
} as const;

export type RedeemableCodeType = (typeof RedeemableCodeType)[keyof typeof RedeemableCodeType];

export const ToolType = {
  Image: 'Image',
  Video: 'Video',
  MotionCapture: 'MotionCapture',
  Upscalers: 'Upscalers',
  Audio: 'Audio',
  Compute: 'Compute',
  GameEngines: 'GameEngines',
  Editor: 'Editor',
  LLM: 'LLM',
} as const;

export type ToolType = (typeof ToolType)[keyof typeof ToolType];

export const TechniqueType = {
  Image: 'Image',
  Video: 'Video',
} as const;

export type TechniqueType = (typeof TechniqueType)[keyof typeof TechniqueType];

export const AppealStatus = {
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected',
} as const;

export type AppealStatus = (typeof AppealStatus)[keyof typeof AppealStatus];

export const AuctionType = {
  Model: 'Model',
  Image: 'Image',
  Collection: 'Collection',
  Article: 'Article',
} as const;

export type AuctionType = (typeof AuctionType)[keyof typeof AuctionType];

export const ModerationRuleAction = {
  Approve: 'Approve',
  Block: 'Block',
  Hold: 'Hold',
} as const;

export type ModerationRuleAction = (typeof ModerationRuleAction)[keyof typeof ModerationRuleAction];

export const ChangelogType = {
  Feature: 'Feature',
  Bugfix: 'Bugfix',
  Policy: 'Policy',
  Update: 'Update',
  Incident: 'Incident',
} as const;

export type ChangelogType = (typeof ChangelogType)[keyof typeof ChangelogType];

export const NewOrderRankType = {
  Acolyte: 'Acolyte',
  Knight: 'Knight',
  Templar: 'Templar',
} as const;

export type NewOrderRankType = (typeof NewOrderRankType)[keyof typeof NewOrderRankType];

export const ChallengeSource = {
  System: 'System',
  Mod: 'Mod',
  User: 'User',
} as const;

export type ChallengeSource = (typeof ChallengeSource)[keyof typeof ChallengeSource];

export const ChallengeStatus = {
  Scheduled: 'Scheduled',
  Active: 'Active',
  Completing: 'Completing',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
} as const;

export type ChallengeStatus = (typeof ChallengeStatus)[keyof typeof ChallengeStatus];

export const PrizeMode = {
  Fixed: 'Fixed',
  Dynamic: 'Dynamic',
} as const;

export type PrizeMode = (typeof PrizeMode)[keyof typeof PrizeMode];

export const PoolTrigger = {
  Entry: 'Entry',
  User: 'User',
} as const;

export type PoolTrigger = (typeof PoolTrigger)[keyof typeof PoolTrigger];

export const ChallengeReviewCostType = {
  None: 'None',
  PerEntry: 'PerEntry',
  Flat: 'Flat',
} as const;

export type ChallengeReviewCostType =
  (typeof ChallengeReviewCostType)[keyof typeof ChallengeReviewCostType];

export const ChallengeIngestionStatus = {
  Pending: 'Pending',
  Scanned: 'Scanned',
  Blocked: 'Blocked',
  Error: 'Error',
} as const;

export type ChallengeIngestionStatus =
  (typeof ChallengeIngestionStatus)[keyof typeof ChallengeIngestionStatus];

export const ChallengeEngagementType = {
  Notify: 'Notify',
} as const;

export type ChallengeEngagementType =
  (typeof ChallengeEngagementType)[keyof typeof ChallengeEngagementType];

export const EntityMetric_EntityType_Type = {
  Image: 'Image',
} as const;

export type EntityMetric_EntityType_Type =
  (typeof EntityMetric_EntityType_Type)[keyof typeof EntityMetric_EntityType_Type];

export const EntityMetric_MetricType_Type = {
  ReactionLike: 'ReactionLike',
  ReactionHeart: 'ReactionHeart',
  ReactionLaugh: 'ReactionLaugh',
  ReactionCry: 'ReactionCry',
  Comment: 'Comment',
  Collection: 'Collection',
  Buzz: 'Buzz',
} as const;

export type EntityMetric_MetricType_Type =
  (typeof EntityMetric_MetricType_Type)[keyof typeof EntityMetric_MetricType_Type];

export const ComicProjectStatus = {
  Active: 'Active',
  Deleted: 'Deleted',
} as const;

export type ComicProjectStatus = (typeof ComicProjectStatus)[keyof typeof ComicProjectStatus];

export const ComicReferenceStatus = {
  Pending: 'Pending',
  Ready: 'Ready',
  Failed: 'Failed',
} as const;

export type ComicReferenceStatus = (typeof ComicReferenceStatus)[keyof typeof ComicReferenceStatus];

export const ComicPanelStatus = {
  Pending: 'Pending',
  Enqueued: 'Enqueued',
  Generating: 'Generating',
  AwaitingSelection: 'AwaitingSelection',
  RequireUnlock: 'RequireUnlock',
  Ready: 'Ready',
  Failed: 'Failed',
} as const;

export type ComicPanelStatus = (typeof ComicPanelStatus)[keyof typeof ComicPanelStatus];

export const ComicChapterStatus = {
  Draft: 'Draft',
  Published: 'Published',
  Scheduled: 'Scheduled',
} as const;

export type ComicChapterStatus = (typeof ComicChapterStatus)[keyof typeof ComicChapterStatus];

export const ComicReferenceType = {
  Character: 'Character',
  Location: 'Location',
  Item: 'Item',
  Style: 'Style',
} as const;

export type ComicReferenceType = (typeof ComicReferenceType)[keyof typeof ComicReferenceType];

export const ComicEngagementType = {
  None: 'None',
  Notify: 'Notify',
  Hide: 'Hide',
} as const;

export type ComicEngagementType = (typeof ComicEngagementType)[keyof typeof ComicEngagementType];

export const ComicGenre = {
  Action: 'Action',
  Adventure: 'Adventure',
  Comedy: 'Comedy',
  Drama: 'Drama',
  Fantasy: 'Fantasy',
  Horror: 'Horror',
  Mystery: 'Mystery',
  Romance: 'Romance',
  SciFi: 'SciFi',
  SliceOfLife: 'SliceOfLife',
  Thriller: 'Thriller',
  Other: 'Other',
} as const;

export type ComicGenre = (typeof ComicGenre)[keyof typeof ComicGenre];

export const UserRestrictionStatus = {
  Pending: 'Pending',
  Upheld: 'Upheld',
  Overturned: 'Overturned',
} as const;

export type UserRestrictionStatus =
  (typeof UserRestrictionStatus)[keyof typeof UserRestrictionStatus];

export const StrikeReason = {
  BlockedContent: 'BlockedContent',
  RealisticMinorContent: 'RealisticMinorContent',
  CSAMContent: 'CSAMContent',
  TOSViolation: 'TOSViolation',
  HarassmentContent: 'HarassmentContent',
  ProhibitedContent: 'ProhibitedContent',
  ManualModAction: 'ManualModAction',
} as const;

export type StrikeReason = (typeof StrikeReason)[keyof typeof StrikeReason];

export const StrikeStatus = {
  Active: 'Active',
  Expired: 'Expired',
  Voided: 'Voided',
} as const;

export type StrikeStatus = (typeof StrikeStatus)[keyof typeof StrikeStatus];

export const WildcardSetKind = {
  System: 'System',
  User: 'User',
} as const;

export type WildcardSetKind = (typeof WildcardSetKind)[keyof typeof WildcardSetKind];

export const WildcardSetAuditStatus = {
  Pending: 'Pending',
  Clean: 'Clean',
  Mixed: 'Mixed',
  Dirty: 'Dirty',
} as const;

export type WildcardSetAuditStatus =
  (typeof WildcardSetAuditStatus)[keyof typeof WildcardSetAuditStatus];

export const WildcardSetCategoryAuditStatus = {
  Pending: 'Pending',
  Clean: 'Clean',
  Dirty: 'Dirty',
} as const;

export type WildcardSetCategoryAuditStatus =
  (typeof WildcardSetCategoryAuditStatus)[keyof typeof WildcardSetCategoryAuditStatus];

export const ReviewVerdict = {
  TruePositive: 'TruePositive',
  FalsePositive: 'FalsePositive',
  TrueNegative: 'TrueNegative',
  FalseNegative: 'FalseNegative',
  Unsure: 'Unsure',
} as const;

export type ReviewVerdict = (typeof ReviewVerdict)[keyof typeof ReviewVerdict];

export const Model3DStatus = {
  Draft: 'Draft',
  Published: 'Published',
  Unpublished: 'Unpublished',
  Deleted: 'Deleted',
} as const;

export type Model3DStatus = (typeof Model3DStatus)[keyof typeof Model3DStatus];

export const Model3DEngagementType = {
  Favorite: 'Favorite',
  Hide: 'Hide',
  Notify: 'Notify',
} as const;

export type Model3DEngagementType =
  (typeof Model3DEngagementType)[keyof typeof Model3DEngagementType];

export const ShopifyMerchOrderStatus = {
  Pending: 'Pending',
  Granted: 'Granted',
} as const;

export type ShopifyMerchOrderStatus =
  (typeof ShopifyMerchOrderStatus)[keyof typeof ShopifyMerchOrderStatus];

export const OutboxEntity = {
  Article: 'Article',
  Image: 'Image',
  Model: 'Model',
  Post: 'Post',
  ModelVersion: 'ModelVersion',
} as const;

export type OutboxEntity = (typeof OutboxEntity)[keyof typeof OutboxEntity];

export const UserHubSourceType = {
  User: 'User',
  Model: 'Model',
  ModelVersion: 'ModelVersion',
  Collection: 'Collection',
} as const;

export type UserHubSourceType = (typeof UserHubSourceType)[keyof typeof UserHubSourceType];
